import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * Manages the state of objects in dotcms-js so compoents can Observe changes and reload as needed
 */
var SiteBrowserState = (function () {
    function SiteBrowserState() {
        this.currentSiteSubject = new BehaviorSubject(null);
        this.currentFolderSubject = new BehaviorSubject(null);
        this.currentURISubject = new BehaviorSubject(null);
        this.currentTreeableSubject = new BehaviorSubject(null);
        this.currentSettingsUpdatedSubject = new BehaviorSubject(null);
        this.currentFolder = this.currentFolderSubject.asObservable();
        this.currentSetingsUpdated = this.currentSettingsUpdatedSubject.asObservable();
        this.currentSite = this.currentSiteSubject.asObservable();
        this.currentTreeable = this.currentTreeableSubject.asObservable();
        this.currentURI = this.currentURISubject.asObservable();
    }
    SiteBrowserState.prototype.changeSite = function (siteName) {
        this.currentSiteSubject.next(siteName);
    };
    SiteBrowserState.prototype.getSelectedSite = function () {
        return this.currentSiteSubject.getValue();
    };
    SiteBrowserState.prototype.changeFolder = function (folderName) {
        this.currentFolderSubject.next(folderName);
    };
    SiteBrowserState.prototype.getSelectedFolder = function () {
        return this.currentFolderSubject.getValue();
    };
    SiteBrowserState.prototype.changeURI = function (uri) {
        this.currentURISubject.next(uri);
    };
    SiteBrowserState.prototype.getURI = function () {
        return this.currentURISubject.getValue();
    };
    SiteBrowserState.prototype.changeTreeable = function (treeable) {
        this.currentTreeableSubject.next(treeable);
    };
    SiteBrowserState.prototype.getSelectedTreeable = function () {
        return this.currentTreeableSubject.getValue();
    };
    SiteBrowserState.prototype.changeSettingsUpdated = function (settingsUpdated) {
        this.currentSettingsUpdatedSubject.next(settingsUpdated);
    };
    SiteBrowserState.prototype.getSettingsUpdated = function () {
        return this.currentSettingsUpdatedSubject.getValue();
    };
    return SiteBrowserState;
}());
export { SiteBrowserState };
SiteBrowserState.decorators = [
    { type: Injectable },
];
/** @nocollapse */
SiteBrowserState.ctorParameters = function () { return []; };
//# sourceMappingURL=site-browser.state.js.map